import React from "react";

import { Icon, WrappingIconProps } from "../Icon";

export const KeyIcon = (props: WrappingIconProps) => {
  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M13.7958 3.20234L16.7975 6.20401C17.0202 6.42664 17.1968 6.69095 17.3173 6.98186C17.4378 7.27276 17.4998 7.58455 17.4998 7.89942C17.4998 8.2143 17.4378 8.52609 17.3173 8.81699C17.1968 9.10789 17.0202 9.37221 16.7975 9.59484L14.595 11.7973C14.3724 12.02 14.1081 12.1966 13.8171 12.3171C13.5262 12.4377 13.2145 12.4997 12.8996 12.4997C12.5847 12.4997 12.2729 12.4377 11.982 12.3171C11.6911 12.1966 11.4268 12.02 11.2042 11.7973L10.9533 11.5465L5.48833 17.0115C5.21143 17.2884 4.8459 17.4589 4.45583 17.4932L4.31 17.4998H3.33333C3.12922 17.4998 2.93222 17.4249 2.77969 17.2892C2.62716 17.1536 2.52971 16.9667 2.50583 16.764L2.5 16.6665V15.6898C2.5001 15.2985 2.63786 14.9198 2.88917 14.6198L2.98833 14.5115L3.33333 14.1665H5V12.4998H6.66667V10.8332L8.45333 9.04651L8.2025 8.79567C7.97983 8.57304 7.8032 8.30873 7.68269 8.01782C7.56219 7.72692 7.50016 7.41513 7.50016 7.10026C7.50016 6.78538 7.56219 6.47359 7.68269 6.18269C7.8032 5.89179 7.97983 5.62747 8.2025 5.40484L10.405 3.20234C10.6276 2.97967 10.8919 2.80304 11.1828 2.68253C11.4738 2.56203 11.7855 2.5 12.1004 2.5C12.4153 2.5 12.7271 2.56203 13.018 2.68253C13.3089 2.80304 13.5732 2.97967 13.7958 3.20234Z"
          stroke={"var(--mode-vector-neutral-default, #8b9397)"}
          stroke-width="1.66667"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.5 7.5H12.5083"
          stroke={"var(--mode-vector-neutral-default, #8b9397)"}
          stroke-width="1.66667"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </Icon>
  );
};
